export var NotificationType;
(function (NotificationType) {
    NotificationType["CompanyGradeChange"] = "company-grade-change";
    NotificationType["NewCoverageAfterInsistence"] = "new-coverage-after-insistence";
    NotificationType["NoCoverageAfterInsistence"] = "no-coverage-after-insistence";
    NotificationType["NewPolicyImported"] = "new-policy-imported";
})(NotificationType || (NotificationType = {}));
